export const addEventListener = (element: any, event:any , handlerFunction : any, flag = false) => (element || window)?.addEventListener(event , handlerFunction, flag);

export const removeEventListener = (element: any, event:any , handlerFunction: any) => (element || window)?.removeEventListener(event , handlerFunction);
